import { schoolList } from './schoolListHC'


export default schoolList
